import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AssetStatus} from '../../models/asset-status';
import {MultiSelectComponent, MultiSelectFilter} from '../multi-select-component';
import {MatMenu, MatMenuTrigger} from '@angular/material/menu';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatDivider} from '@angular/material/divider';
import {MatButton} from '@angular/material/button';

/**
 * This component allows to create a multi-select filter of Asset Status entities.
 * It either emits 'undefined' value if no filter is set or an array of entities.
 *
 * In addition, it saves the state of the filter to URL params and browser's storage.
 */

@Component({
  selector: 'app-asset-status-filter',
  templateUrl: './asset-status-filter.component.html',
  styleUrls: ['./asset-status-filter.component.scss'],
  imports: [
    MatCheckbox,
    MatDivider,
    MatButton
  ]
})
export class AssetStatusFilterComponent extends MultiSelectComponent<AssetStatus> implements OnInit {

  SETTINGS_KEY = 'selectedAssetStatusIds';
  USE_FULLY_CHECKED_AS_DEFAULT = false;

  @Input() origin;
  @Output() filterChanged = new EventEmitter<MultiSelectFilter<AssetStatus>>();

  @ViewChild('menu') menu: MatMenu;
  @ViewChild('matTriggerIs') matTriggerIs: MatMenuTrigger;
  @ViewChild('matTriggerIsNot') matTriggerIsNot: MatMenuTrigger;

  constructor() {
    super();
  }

  ngOnInit() {
    this.initComponent(AssetStatus.getAll());
  }

  getLabel(item: AssetStatus): string {
    return item.label;
  }

  onApply() {}

  openMenu() {}
}
